"use strict";

var React = require("react");

var SvgIconArrowIndicator45Deg = function SvgIconArrowIndicator45Deg() {
  return /*#__PURE__*/ React.createElement(
    "svg",
    {
      viewBox: "0 0 14 18",
      height: "1em",
      width: "1em",
    },
    /*#__PURE__*/ React.createElement(
      "g",
      {
        fill: "none",
        fillRule: "evenodd",
      },
      /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        d:
          "M11.247 6.178l-.01-5.647L5.59.521 7.71 2.644 2.759 7.595 4.173 9.01l4.952-4.952z",
      }),
      /*#__PURE__*/ React.createElement("path", {
        fill: "#cdcdcd",
        d:
          "M9.827 9.012l-4.952 4.952-2.122-2.12.01 5.646 5.647.01-2.121-2.121 4.952-4.953z",
      }),
      /*#__PURE__*/ React.createElement("path", {
        d: "M7.008 25.974L-9.963 9.004 6.992-7.953l16.971 16.97z",
      })
    )
  );
};

exports["foreignIcon"] = SvgIconArrowIndicator45Deg;
